// File: src/App.js
import React from 'react';
import SPPLGenerator from './SPPLGenerator'; // Panggil file yang baru kita buat

function App() {
  return (
    <div className="App">
      <SPPLGenerator />
    </div>
  );
}

export default App;